import resources from './resources';

export const config = {
  interpolation: { escapeValue: false }, // React already does escaping
  lng: 'ptbr',
  resources,
  defaultNS: 'common',
};

export { resources };
